import React from 'react';
import { translateStatus } from '../../lib/statusTranslate';
import './statusBadge.scss';

const StatusBadge = ({ status }) => {
  const getVariant = (status) => {
    if (['completed', 'contacted', 'closed'].includes(status)) {
      return 'completed';
    }
    if (['in_progress', 'received'].includes(status)) {
      return 'progress';
    }
    if (['awaiting_contact'].includes(status)) {
      return 'awaiting';
    }
    return 'closed';
  };

  return (
    <div className={`status-badge status-badge--${getVariant(status)}`}>
      <span className="status-badge__dot" />
      {translateStatus(status)}
    </div>
  );
};

export default StatusBadge;
